import { FunctionComponent } from "react";
import * as Styled from "./styles";

interface SpacingProps {
  vertical?: string;
  horizontal?: string;
  token?: string;
}

/**
 * `Spacing`
 * Renders an invisible div used as a spacer with customizable vertical and horizontal margins.
 *
 * @param {string} vertical - Vertical margin in pixels, defaults to "0".
 * @param {string} horizontal - Horizontal margin in pixels, defaults to "0".
 */
const Spacing: FunctionComponent<SpacingProps> = ({
  vertical = undefined,
  horizontal = undefined,
  token = undefined,
}) => {
  return <Styled.SpacingDiv $vertical={vertical} $horizontal={horizontal} $token={token}></Styled.SpacingDiv>;
};

export default Spacing;
